var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"slot":"append"},slot:"append"},[_c('v-list-tile',{staticClass:"custom-height"},[_c('hr')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }